import { get, isEmpty } from "lodash";
import { RequestContactUpdateState } from "../models";

export const MAX_CONTACT_NAME_LENGTH = 200;
export const MAX_CONTACT_EMAIL_LENGTH = 300;

export const isValidEmail = (email: string): boolean => {
  if (!email || !email.trim()) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return emailRegex.test(email.trim());
};

export const isValidName = (name: string): boolean => {
  if (!name || !name.trim()) return false;
  const nameRegex = /^[A-Za-z ]*$/;

  return nameRegex.test(name.trim());
};

export const hasValidationErrors = (state: RequestContactUpdateState, baseRequiredPaths: string[]): boolean => {
  // Check required emptiness (treat whitespace-only strings as empty)
  const hasEmpty = baseRequiredPaths.some((path) => {
    const val = get(state, path);

    if (typeof val === "string") {
      return val.trim().length === 0;
    }

    return isEmpty(val);
  });

  // Validate email format if contactEmail is provided
  const contactEmail = state.commonFields.contactEmail;
  const hasInvalidEmail = Boolean(contactEmail && contactEmail.trim().length > 0 && !isValidEmail(contactEmail));

  // Check max length validation
  const contactName = state.commonFields.contactName;
  const hasInvalidName = Boolean(contactName && contactName.trim().length > 0 && !isValidName(contactName));
  const hasExceededNameLength = Boolean(contactName && contactName.length > MAX_CONTACT_NAME_LENGTH);
  const hasExceededEmailLength = Boolean(contactEmail && contactEmail.length > MAX_CONTACT_EMAIL_LENGTH);

  return hasEmpty || hasInvalidEmail || hasInvalidName || hasExceededNameLength || hasExceededEmailLength;
};
